import Cookies from 'js-cookie';

const tokenKey = 'Access-Token';
const centerKey = 'center';
const departKey = 'depart';
const cityKey = 'city';
const nameKey = 'name';
const empCodeKey = 'empCode';
const projectListKey='projectList'

export function setToken(token) {
    return Cookies.set(tokenKey,token)
}

export function getToken(){
    return Cookies.get(tokenKey)
}

export function setCenter(center){
    return Cookies.set(centerKey,center)
}

export function getCenter(){
    return Cookies.get(centerKey)
}

export function setDepart(depart){
    return Cookies.set(departKey,depart);
}

export function getDepart(){
    return Cookies.get(departKey)
}

export function setCity(city){
    return Cookies.set(cityKey,city);
}

export function getCity(){
    return Cookies.get(cityKey)
}

export function setName(name) {
    return Cookies.set(nameKey,name);
}

export function getName(){
    return Cookies.get(nameKey)
}

export function setEmpCode(empCode) {
  return Cookies.set(empCodeKey,empCode);
}

export function getEmpCode(){
  return Cookies.get(empCodeKey)
}

export function getProjectsDate() {
  // return Cookies.get(projectListKey)
  return JSON.parse(localStorage.getItem(projectListKey))

}
export function setProjectsDate(data) {
   // Cookies.set(projectListKey,data)
  window.localStorage.setItem(projectListKey,JSON.stringify(data,null,2))

}
export function getPosition() {
  return Cookies.get('position')

}
export function setPosition(position) {
  return Cookies.set('position',position);

}

// export function getBrandList() {
//     return JSON.parse(localStorage.getItem('brandList'))
// }
// export function setBrandList(data) {
//     window.localStorage.setItem('brandList',JSON.stringify(data,null,2))
// }
export function getAuthCity() {
    return JSON.parse(localStorage.getItem('authCity'))
}
export function setAuthCity(data) {
    window.localStorage.setItem('authCity',JSON.stringify(data,null,2))
}
// export function getCooperationMode() {
//     return JSON.parse(localStorage.getItem('cooperationMode'))
// }
// export function setCooperationMode(data) {
//     window.localStorage.setItem('cooperationMode',JSON.stringify(data,null,2))
// }
export function getProjectListByCondiction() {
    return JSON.parse(localStorage.getItem('projectListByCondiction'))
}
export function setProjectListByCondiction(data) {
    window.localStorage.setItem('projectListByCondiction',JSON.stringify(data,null,2))
}


export function removeInfo() {
    Cookies.remove(tokenKey);
    Cookies.remove(centerKey);
    Cookies.remove(departKey);
    Cookies.remove(cityKey);
    Cookies.remove(nameKey);
    Cookies.remove(empCodeKey);
  // Cookies.remove(projectListKey);
  window.localStorage.removeItem(projectListKey)
  Cookies.remove('position')


}
